import React from "react";
import Team from '../../Components/Team/team';

const Our_Team = () => {
    return (
        <div>
            <Team />
        </div>
    )
}

export default Our_Team;